module.exports = __webpack_public_path__ + "static/media/Blitzle_gaussian2.3d8e86ce.png";